<div
  class="flex flex-column gap-2 md:flex-row md:gap-0 justify-content-center align-items-center mt-2"
>
  <div>
    <div class="font-bold text-xs">Αποτελέσματα</div>
    {{ (currentPage - 1) * pagesize + 1 }} έως
    {{
      totalCount <= (currentPage - 1) * pagesize + pagesize
        ? totalCount
        : (currentPage - 1) * pagesize + pagesize
    }}
    από
    {{ totalCount }}
  </div>

  <p-paginator
    (onPageChange)="onPageChange($event)"
    [first]="(currentPage - 1) * pagesize"
    [rows]="pagesize"
    [totalRecords]="totalCount"
    [rowsPerPageOptions]="[10, 15, 20, 30, 50, 100]"
    [part]="true"
  />
</div>

<ng-template> </ng-template>
